export enum ActionType {
  VOLOP = 'VOLOP',
  DONATION = 'DONATION',
  PETITION = 'PETITION',
  OTHER = 'OTHER',
}

export const ACTION_TYPE: Array<{
  id: ActionType;
  name: string;
}> = [
  {
    id: ActionType.VOLOP,
    name:
      /* TRANSLATORS: "Volunteer +" type */
      getText('Volunteer Opportunity'),
  },
  {
    id: ActionType.DONATION,
    name:
      /* TRANSLATORS: "Volunteer +" type */
      getText('Donation'),
  },
  {
    id: ActionType.PETITION,
    name:
      /* TRANSLATORS: "Volunteer +" type */
      getText('Petition'),
  },
  {
    id: ActionType.OTHER,
    name:
      /* TRANSLATORS: "Volunteer +" type */
      getText('Other Opportunity'),
  },
];
